import { useSite } from "@/context/SiteContext";
import { Kicker, Reveal } from "@/components/Reveal";

export const Leadership = () => {
    const { t } = useSite();
    return (
        <section id="leadership" data-testid="leadership-section" className="theme-fade mesh-light">
            <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-32 lg:px-12 lg:py-40">
                <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
                    <Reveal className="lg:col-span-8">
                        <Kicker>{t.leadership.kicker}</Kicker>
                        <h2 className="headline-section mt-6 max-w-[18ch] font-display font-semibold text-theme-ink" data-testid="leadership-heading">
                            {t.leadership.heading}
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15} className="flex items-end lg:col-span-4">
                        <p className="font-display text-sm font-semibold lowercase tracking-[0.14em] text-sky-ink" data-testid="leadership-cta">
                            {t.leadership.cta}
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:mt-20 xl:grid-cols-4">
                    {t.leadership.members.map((m, i) => (
                        <Reveal key={m.name} delay={i * 0.08}>
                            <article data-testid={`leadership-member-${i}`} className="group w-full max-w-[280px] xl:max-w-[260px]">
                                <div className="relative aspect-[4/5] overflow-hidden rounded-[1.5rem] border border-theme bg-theme-soft shadow-[0_24px_70px_rgba(7,48,119,0.14)]">
                                    {m.img ? (
                                        <img
                                            src={m.img}
                                            alt={m.imgAlt}
                                            loading="lazy"
                                            width="1080"
                                            height="1350"
                                            data-testid={`leadership-portrait-${i}`}
                                            className="h-full w-full object-cover object-top saturate-[0.92] contrast-[1.04] transition-[transform,filter] duration-700 ease-out group-hover:scale-[1.04] group-hover:saturate-100"
                                        />
                                    ) : (
                                        <div className="flex h-full items-center justify-center tile-gradient">
                                            <span aria-hidden="true" className="font-display text-5xl font-semibold tracking-tight text-white/90 sm:text-6xl">
                                                {m.initials}
                                            </span>
                                        </div>
                                    )}
                                    <div
                                        aria-hidden="true"
                                        className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_top,rgba(4,20,46,0.26),transparent_44%)]"
                                    />
                                    <span aria-hidden="true" className="absolute bottom-4 left-4 h-2.5 w-2.5 bg-chitta-yellow" />
                                    <span
                                        aria-hidden="true"
                                        className="absolute inset-x-0 bottom-0 h-px bg-chitta-sky/50 transition-[height] duration-500 group-hover:h-1"
                                    />
                                </div>
                                {!m.img && <p className="sr-only">{t.leadership.portraitNote}</p>}
                                <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-theme-ink">{m.name}</h3>
                                <p className="mt-1.5 text-base font-semibold text-sky-ink">{m.title}</p>
                                <p className="mt-3 text-base leading-[1.75] text-theme-muted">{m.line}</p>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
